import styled from 'styled-components';

export const WrapperCheck = styled.div`
  display: flex;
  align-items: center;
`;

export const WrapperCheckLable = styled.div`
  margin-inline-start: ${({ theme }) => theme.spacing.x3};
`;
